import script from "./PlayerMarker.vue?vue&type=script&lang=ts"
export * from "./PlayerMarker.vue?vue&type=script&lang=ts"

export default script